import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import DashboardTile from '../DashboardTile';
import { getUsers } from '../../services/tenantService';
import { getTenants } from '../../services/tenantService';
import { getClaims } from '../../services/membershipService';
import './AdminDashboard.css';

const StatCard = ({ label, value, color }) => (
  <div className="admin-stat-card" style={{ borderLeftColor: color }}>
    <span className="admin-stat-value">{value ?? '—'}</span>
    <span className="admin-stat-label">{label}</span>
  </div>
);

const AdminDashboard = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState({ users: null, tenants: null, pendingClaims: null });

  useEffect(() => {
    let alive = true;
    Promise.allSettled([
      getUsers(),
      getTenants(),
      getClaims({ status: 'pending' }),
    ]).then(([usersRes, tenantsRes, claimsRes]) => {
      if (!alive) return;
      setStats({
        users:         usersRes.status   === 'fulfilled' ? (usersRes.value.data?.length   ?? usersRes.value.data?.total ?? '?') : '?',
        tenants:       tenantsRes.status === 'fulfilled' ? (tenantsRes.value.data?.length ?? tenantsRes.value.data?.total ?? '?') : '?',
        pendingClaims: claimsRes.status  === 'fulfilled' ? (claimsRes.value.data?.length  ?? claimsRes.value.data?.total ?? '?') : '?',
      });
    });
    return () => { alive = false; };
  }, []);

  const tiles = [
    { title: 'Manage Communities', icon: '🏘️', description: 'Create, review and configure tenant communities', path: '/admin', color: '#4285F4' },
    { title: 'Manage Users',       icon: '👥', description: 'View, edit and assign roles to platform users', path: '/admin', color: '#0F9D58' },
    { title: 'Membership Claims',  icon: '📋', description: 'Review pending community membership applications', path: '/admin', color: '#F4B400', badge: typeof stats.pendingClaims === 'number' && stats.pendingClaims > 0 ? stats.pendingClaims : undefined },
    { title: 'Lenses',             icon: '🔭', description: 'Configure and run intelligence lenses', path: '/lenses', color: '#9C27B0' },
    { title: '7 Generation Plan',  icon: '🌀', description: 'Long-range planning assessment tool', path: '/seven-gen', color: '#FF5722' },
    { title: 'Pipeline',           icon: '⚙️', description: 'Data processing and export pipeline', path: '/pipeline', color: '#607D8B' },
    { title: 'Reports',            icon: '📊', description: 'View generated platform reports', path: '/reports', color: '#00BCD4' },
    { title: 'Land Intelligence',  icon: '🗺️', description: 'Land unit evaluations and assessments', path: '/land-units', color: '#8BC34A' },
  ];

  return (
    <div className="panel-dashboard admin-dashboard">
      <div className="panel-dashboard__header">
        <div>
          <h1>Admin Dashboard</h1>
          <p>Welcome, {user?.firstName || user?.email} — platform administrator</p>
        </div>
        <Link to="/admin" className="btn btn--primary">Admin Panel →</Link>
      </div>

      <div className="admin-stats-row">
        <StatCard label="Total Users"      value={stats.users}         color="#4285F4" />
        <StatCard label="Communities"      value={stats.tenants}       color="#0F9D58" />
        <StatCard label="Pending Claims"   value={stats.pendingClaims} color="#F4B400" />
      </div>

      <h2 className="panel-dashboard__section-title">Platform Tools</h2>
      <div className="tile-grid">
        {tiles.map((t) => <DashboardTile key={t.title} {...t} />)}
      </div>
    </div>
  );
};

export default AdminDashboard;
